import React from 'react';
import PropTypes from 'prop-types';
import {Backdrop, Modal, Paper, Button, Box} from '@mui/material';
import {useIntl} from 'react-intl';
import useStyles from './styles';

function QuoteExpiredModal({open, onConfirm}) {
  const {classes} = useStyles();
  const intl = useIntl();

  return (
    <Modal
      open={open}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{timeout: 500}}
    >
      <Paper className={classes.paper}>
        <div className={classes.modalHeader}>
          <Box onClick={onConfirm}><span className={classes.buttonDismiss}/></Box>
        </div>
        <div className={classes.modalBody}>
          <h3 className={classes.title}>
            {intl.formatMessage({id: 'payment.quote_expired_title'})}
          </h3>
          <p className={classes.subtitle}>
            {intl.formatMessage({id: 'payment.quote_expired_text'})}
          </p>
          <div className={classes.buttonWrapper}>
            <Button
              variant='contained'
              color='primary'
              className={classes.confirmButton}
              onClick={onConfirm}
            >
              {intl.formatMessage({id: 'payment.quote_expired_button'})}
            </Button>
          </div>
        </div>
      </Paper>
    </Modal>
  );
}

QuoteExpiredModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default QuoteExpiredModal;
